import React from 'react';
import { Button, Typography } from '@mui/material';
import BaseDialog from './BaseDialog';

interface UnsavedChangesDialogProps {
    open: boolean;
    onStay: () => void;
    onLeave: () => void;
    title?: string;
    message?: string;
}

const UnsavedChangesDialog: React.FC<UnsavedChangesDialogProps> = ({
    open,
    onStay,
    onLeave,
    title = 'Unsaved Changes',
    message = 'You have unsaved changes. Are you sure you want to leave?'
}) => {
    return (
        <BaseDialog
            open={open}
            onClose={onStay}
            title={title}
            maxWidth="xs"
            showCloseButton={false}
            actions={
                <>
                    <Button
                        variant="outlined"
                        color="error"
                        onClick={onLeave}
                    >
                        Leave
                    </Button>
                    <Button
                        variant="contained"
                        onClick={onStay}
                    >
                        Stay
                    </Button>
                </>
            }
        >
            <Typography sx={{ mt: 2 }}>
                {message}
            </Typography>
        </BaseDialog>
    );
};

export default UnsavedChangesDialog;
